<ag-grid-angular [rowData]="summary()" [columnDefs]="columnDefs" [gridOptions]="tableDef" [loading]="isLoading()"></ag-grid-angular>
